const Fetcher = require('od-modules/utils/fetcher');
const DEPARTURE_FLIGHT_CODE_TEMPLATE = 'd';
const MULTI_FLIGHT_CODE_TEMPLATE = 'm';
const RETURN_FLIGHT_CODE_TEMPLATE = 'r';
const FLIGHT_CODE_DELIMITER = '_';
const storeData = require('./storeData.utils');
const trackingKeys = ['category', 'action', 'label', 'page', 'funnel', 'legacy', 'analytics'];
const labelsAllowedInFirstBatch = ['batches_onload', 'lazyloading_onload', 'blocks_clicked'];

const isValid = function(str) {
    return Odigeo._.isString(str) && !Odigeo._.isEmpty(str);
};
const triggerTracking = function(type, data) {
    Odigeo.trigger('analytics:tracking', {
        type: type,
        data: data,
    });
};
const prepareEcommerceData = function(ecommerceData, type = 'default') {
    return {
        'postBookingAncillaries': addPostBookingAncillariesId,
        'default': Odigeo._.identity,
    }[type](ecommerceData);
};
const addPostBookingAncillariesId = function(ecommerceData) {
    const itineraryBooking = storeData.get('bookingInfo', 'itineraryBookings');
    const departureIata = Odigeo._.get(itineraryBooking, 'bookingItinerary.departure.cityIataCode');
    const arrivalIata = Odigeo._.get(itineraryBooking, 'bookingItinerary.arrival.cityIataCode');
    ecommerceData.ancillaryItemsUniversal.forEach(function(item) {
        item.id = arrivalIata ? departureIata + '-' + arrivalIata : departureIata;
    });
    return ecommerceData;
};
const counterMetric = function(key, extraTokens) {
    if (Odigeo.Session.get('disableGrafana') !== 'true') {
        Fetcher.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('counterMetric/' + key), extraTokens || {}).json();
    }
};

const isEventTrackingAllowed = function(label) {
    const isResultsFirstBatch = Odigeo.Session.get('isFirstBatch');
    const isLabelAllowed = labelsAllowedInFirstBatch.includes(label);

    return isResultsFirstBatch !== false || isLabelAllowed;
};

module.exports = {
    bindEvents: function($page) {
        $page.off('.tracking').on(
            Odigeo.Events.tap + '.tracking', '[data-auto-tracking]',
            Odigeo._.bind(this.processTrackingHandler, this, _, Odigeo.History.getPageNameFromFragment())
        );
        Odigeo.off('widgetstracking:eventtrack')
            .on('widgetstracking:eventtrack', Odigeo._.partial(this.processTracking, _, Odigeo.History.getPageNameFromFragment().split('/')[0]));
    },
    trackEvent: function(action, label, page, optimize = false, analytics = true) {
        if (isValid(action) && isValid(label) && isEventTrackingAllowed(label)) {
            this.processTracking({
                action: action,
                label: label,
                analytics: analytics,
            }, page);
        }
    },
    trackPage: function(page, config) {
        Odigeo.trigger('analytics:tracking', {
            type: 'trackVirtualPage',
            data: {
                page: page,
                funnel: Odigeo._.result(config, 'funnel', true),
                legacy: Odigeo._.result(config, 'legacy'),
                error: Odigeo._.result(config, 'error'),
                eCommerce: Odigeo._.result(config, 'eCommerce'),
                customDimensions: Odigeo._.result(config, 'customDimensions', {}),
            },
        });
    },
    setCustomDimension: function(index, value) {
        Odigeo.trigger('analytics:tracking', {
            type: 'setCustomDimension',
            data: {
                customDimension: index,
                value: value,
            },
        });
    },
    setCustomParam: function(name, value) {
        Odigeo.trigger('analytics:tracking', {
            type: 'setCustomDimension',
            data: {
                customParam: name,
                value: value,
            },
        });
    },
    processTrackingHandler: function(ev, page) {
        var $elTracking = $(ev.currentTarget);
        var optionsTracking = Odigeo._.clone($elTracking.data('autoTracking'));

        this.processTracking(optionsTracking, page);
    },
    processTracking: function(optionsTracking, page) {
        var pageToTrack = page || Odigeo.History.getPageNameFromFragment().split('/')[0];
        var dataTracking = Odigeo._.extend({
            category: pageToTrack,
            page: pageToTrack,
        }, Odigeo._.pick(optionsTracking, trackingKeys));
        triggerTracking(!Odigeo._.isUndefined(optionsTracking) && optionsTracking.gaType ? optionsTracking.gaType : 'trackEvent', dataTracking);
    },

    trackEventWithCategory: function(category, action, label) {
        var dataTracking = {
            category: category,
            action: action,
            label: label,
        };
        triggerTracking('trackEvent', dataTracking);
    },

    trackStop: function(key) {
        Fetcher.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('stopMetric/' + key)).text();
    },

    startMetric: function(key) {
        Odigeo.Session.set(key, Date.now());
    },

    stopMetric: function(key) {
        var timeEnd = Date.now();
        var timeInit = Odigeo.Session.get(key);
        var disableGrafana = Odigeo.Session.get('disableGrafana');

        Odigeo.Session.remove(key);
        if (disableGrafana !== 'true' && !!timeInit) {
            Fetcher.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('trackTime'), {
                key: key,
                time: timeEnd - timeInit,
            }).json();
        }
    },

    counterMetric: counterMetric,

    trackTimeMetric: function(key, timeInit) {
        Fetcher.post(Odigeo.Settings.getProperty('metricServiceUrlFormatter')('trackTime'), {
            key: key,
            time: Odigeo.Utils.getDifferenceInMilliseconds(timeInit, new Date()),
        }).json();
    },

    trackEventIfCondition: function(category, action, label, condition) {
        if (condition) {
            this.trackEventWithCategory(category, action, label);
        }
    },

    addCrossDomainIframesTracking: function() {
        var iframes = $('iframe.tracking-cross-domain');
        Odigeo._.forEach(iframes, function(iFrame) {
            triggerTracking('addCrossDomainIframeTracking', iFrame);
        });
    },

    openExternalLink: function(url, onlyUniversal) {
        var dataTracking = {
            url: url,
            goOutside: true,
            onlyUniversal: onlyUniversal || false,
        };
        triggerTracking('sendToPageBlank', dataTracking);
    },

    trackPromo: function($promo, isClick, index) {
        triggerTracking('trackPromo', {
            promo: {
                'id': $promo.data('track-id'),
                'name': $promo.data('track-name'),
                'creative': $promo.data('track-creative'),
                'position': $promo.data('track-position'),
            },
            isClick: isClick,
            index: index,
        });
    },

    trackInternalCampaigns: function() {
        var $internalCampaigns = $('.internal-campaign-tracking');
        Odigeo._.forEach($internalCampaigns, (promo, index) => {
            var $promo = $(promo);
            this.trackPromo($promo, false, index+1);
            $promo.on(Odigeo.Events.tap, Odigeo._.bind(this.trackPromo, this, $promo, true, index+1));
        });
        triggerTracking('trackPromo', {
            promo: {
                'id': 'XX',
                'name': 'XX',
                'creative': 'XX',
                'position': 'XX',
            },
            isClick: false,
            index: -1,
        });
    },

    decorateAppTouchpointUrl: function(url) {
        var decoratedUrl = '';
        Odigeo.requireWidget('google-analytics', 'googleanalytics', function(googleanalytics) {
            decoratedUrl = googleanalytics.get('getDecoratedAppTouchpointUrl', url);
        });
        return decoratedUrl;
    },
    trackEcommerce: function(ecommerceData, type) {
        triggerTracking('trackECommerce', prepareEcommerceData(ecommerceData, type));
    },

    customDimensionFormatter: function(segmentsPreselected) {
        return Odigeo._.map(segmentsPreselected, function(segment, index) {
            let flightCode = segment.key ? segment.key : segment;
            if (RegExp('^[0-9]').test(flightCode)) {
                flightCode = flightCode.substr(flightCode.indexOf(',') + 1);
            }
            if (index === 0) {
                return `${DEPARTURE_FLIGHT_CODE_TEMPLATE}:${flightCode}`;
            } else {
                return JSON.parse(Odigeo.Session.storage.searchParameters).type === 'multipleTrip' ?
                    `${MULTI_FLIGHT_CODE_TEMPLATE}${index}:${flightCode}`
                    : `${RETURN_FLIGHT_CODE_TEMPLATE}:${flightCode}`;
            }
        }).join(FLIGHT_CODE_DELIMITER);
    },

    trackHomeContinuance: function(toPage) {
        const version = Odigeo.Session.get('of_home_version') || 'unset';
        counterMetric('HOME_CONTINUANCE', {
            HOME_VERSION: version.replace(/\./g, '_'),
            PAGE: toPage,
        });
    },

    trackOneFrontContinuance: ({from = {}, to = {}} = {}) => {
        const hasUserNavigate =
            !Odigeo._.isNull(from) && !Odigeo._.isNull(to) && Odigeo._.size(from.name) && Odigeo._.size(to.name) && from.name !== to.name;

        if (hasUserNavigate) {
            counterMetric('ONEFRONT_CONTINUANCE', {
                FROM: from.name,
                TO: to.name,
            });
        }
    },

    /*
     * Compose a tracking label from a 'prefix' and 'key:value' pairs joined by an '_' in a given order.
     * @param labelPrefix - String - the
     * @param paramOrder - Array - The params to track as a list of keys in trackingInfoObj.
     * @param trackingInfoObj - Object - The key-value pairs with the info
     * @return String - the composed label. Example: composeLabel('foo', ['bar','qux'], {bar: 1, qux:2}) returns foo_bar:1_qux:2
     */
    composeLabel: (labelPrefix = '', paramOrder = [], trackingInfoObj = {}) => {
        return paramOrder.reduce((composedLabel, paramName) => {
            return `${composedLabel}_${paramName}:${trackingInfoObj[paramName]}`;
        }, labelPrefix);
    },
};
